import { createContext, type ReactNode, useContext, useMemo } from 'react'

import { type WiggleType } from '@/defs/input'

type FilterFormContext = {
  attempts: number
  invalid: boolean
}

const FilterFormContext = createContext<FilterFormContext | null>(null)

type Props = {
  children: ReactNode
} & FilterFormContext

export const FilterFormProvider = ({ attempts, children, invalid }: Props) => {
  const value = useMemo(() => ({ attempts, invalid }), [attempts, invalid])

  return <FilterFormContext.Provider value={value}>{children}</FilterFormContext.Provider>
}

export const useFilterForm = () => {
  const filterForm = useContext(FilterFormContext)

  if (!filterForm) throw new Error('useFilterForm must be used within a FilterForm component')

  return filterForm
}

type UseFilterFormErrorType = {
  warn: boolean
  wiggle?: WiggleType
}

export const useFilterFormError = (invalid: boolean): UseFilterFormErrorType => {
  const { attempts } = useFilterForm()

  return {
    warn: invalid && attempts > 0,
    wiggle: invalid && attempts > 1 ? (attempts % 2 === 0 ? 'a' : 'b') : undefined,
  }
}
